(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[890],{

/***/ 45958:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms",
      function () {
        return __webpack_require__(94822);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TermsOfUse": function() { return /* binding */ TermsOfUse; },
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _platform_shared_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39012);
/* harmony import */ var _platform_data_access__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9432);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _platform_website_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41898);
/* harmony import */ var _platform_website_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68579);
/* harmony import */ var _platform_website_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90573);
/* harmony import */ var _platform_website_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25352);
/* harmony import */ var _platform_website_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46087);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49661);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);






const SEO = {
    title: "Olby // Terms of use"
};
var __N_SSP = true;
const TermsOfUse = ()=>{
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,_platform_website_components__WEBPACK_IMPORTED_MODULE_2__/* .useUpdateHeader */ .G)(contentRef, _platform_website_components__WEBPACK_IMPORTED_MODULE_3__/* .HEADER_THEMES.NEUTRAL_BACKGROUND */ ._.NEUTRAL_BACKGROUND);
    (0,_platform_website_components__WEBPACK_IMPORTED_MODULE_4__/* .useCleanHeader */ ._)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["terms-container"]),
        ref: contentRef,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["terms-wrapper"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_platform_website_components__WEBPACK_IMPORTED_MODULE_6__/* .WebsiteSeo */ .P, {
                    seo: SEO
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_platform_shared_components__WEBPACK_IMPORTED_MODULE_7__/* .Terms */ .F, {
                    type: _platform_data_access__WEBPACK_IMPORTED_MODULE_8__/* .TermType.TermsOfUse */ .K5.TermsOfUse,
                    role: _platform_data_access__WEBPACK_IMPORTED_MODULE_8__/* .Role.Global */ .uU.Global,
                    isFetchEnabled: false
                })
            ]
        })
    });
};
TermsOfUse.getLayout = (page)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_platform_website_components__WEBPACK_IMPORTED_MODULE_9__/* .WebsiteLayout */ .CG, {
        shouldChangeBgColor: true,
        headerInitialTheme: _platform_website_components__WEBPACK_IMPORTED_MODULE_3__/* .HEADER_THEMES.NEUTRAL_BACKGROUND */ ._.NEUTRAL_BACKGROUND,
        children: page
    });
};
/* harmony default export */ __webpack_exports__["default"] = (TermsOfUse);


/***/ }),

/***/ 97885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ customFetcher; }
/* harmony export */ });
const customFetcher = (query, variables, options)=>{
    return async ()=>{
        const NEXT_PUBLIC_API_URL = "https://platform-api.olby.com/graphql";
        const res = await fetch(NEXT_PUBLIC_API_URL || "https://platform-api.olby.com/graphql", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Accept: "application/json",
                ...options
            },
            body: JSON.stringify({
                query,
                variables
            })
        });
        const json = await res.json();
        if (json.errors) {
            const errors = json.errors[0];
            throw errors;
        }
        return json.data;
    };
};


/***/ }),

/***/ 39012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ Terms; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../libs/data-access/src/lib/types.generated.ts
var types_generated = __webpack_require__(9432);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(60431);
// EXTERNAL MODULE: ../../libs/data-access/src/lib/custom-fetcher/index.ts
var custom_fetcher = __webpack_require__(97885);
;// CONCATENATED MODULE: ../../libs/data-access/src/lib/graphql/company/terms/get-current-term-by-role-and-type.generated.ts
/* eslint-disable */ // @ts-nocheck


const GetCurrentTermByRoleAndTypeDocument = "\n    query GetCurrentTermByRoleAndType($input: FindCurrentByRoleAndTypeInput!) {\n  getCurrentTermByRoleAndType(input: $input) {\n    versionDate\n    textHtml\n    versionName\n  }\n}\n    ";
const useGetCurrentTermByRoleAndTypeQuery = (variables, options)=>(0,index_production.useQuery)([
        "GetCurrentTermByRoleAndType",
        variables
    ], (0,custom_fetcher/* customFetcher */.k)(GetCurrentTermByRoleAndTypeDocument, variables), options);
useGetCurrentTermByRoleAndTypeQuery.getKey = (variables)=>[
        "GetCurrentTermByRoleAndType",
        variables
    ];
const useInfiniteGetCurrentTermByRoleAndTypeQuery = (variables, options)=>{
    var _pageParam;
    return (0,index_production.useInfiniteQuery)([
        "GetCurrentTermByRoleAndType.infinite",
        variables
    ], (metaData)=>(0,custom_fetcher/* customFetcher */.k)(GetCurrentTermByRoleAndTypeDocument, {
            ...variables,
            ...(_pageParam = metaData.pageParam) !== null && _pageParam !== void 0 ? _pageParam : {}
        })(), options);
};
useInfiniteGetCurrentTermByRoleAndTypeQuery.getKey = (variables)=>[
        "GetCurrentTermByRoleAndType.infinite",
        variables
    ];
useGetCurrentTermByRoleAndTypeQuery.fetcher = (variables, options)=>(0,custom_fetcher/* customFetcher */.k)(GetCurrentTermByRoleAndTypeDocument, variables, options);

// EXTERNAL MODULE: ../../node_modules/date-fns-tz/index.js
var date_fns_tz = __webpack_require__(22601);
;// CONCATENATED MODULE: ../../libs/utils/src/lib/date.ts



const NY_TIMEZONE = "America/New_York";
const formatDate = (date, dateDisplayFormat)=>{
    if (!date) {
        return "";
    }
    const newDate = typeof date === "string" ? new Date(date) : date;
    return (0,date_fns_tz.formatInTimeZone)(newDate, NY_TIMEZONE, dateDisplayFormat);
};
const getNYUTCOffset = ()=>"UTC".concat(formatDate(new Date(), "XXX"));
const toISODate = (date)=>{
    if (!date) {
        return "";
    }
    return formatISO(date);
};
const dateRange = (startAt, endAt)=>{
    const size = endAt - startAt;
    return [
        ...Array(size).keys()
    ].map((i)=>i + startAt);
};
// DD/MM/YYYY to MM-DD-YYYY
const formatToUS = (date)=>{
    const [day, month, year] = date.split("/");
    return "".concat(month, "-").concat(day, "-").concat(year);
};
// DD/MM/YYYY to Date
const dayMonthYearToDate = (str)=>{
    const yearMonthDay = str.split("/");
    return new Date(Number(yearMonthDay[2]), Number(yearMonthDay[1]) - 1, Number(yearMonthDay[0]));
};
// MM/YYYY to Date
const monthYearToDate = (str)=>{
    const yearMonthDay = str.split("/");
    return new Date(Number(yearMonthDay[1]), Number(yearMonthDay[0]) - 1, 1);
};
// YYYY-MM-DD to MM/YYYY
const ISOToMonthYear = (value)=>{
    if (!value) {
        return "";
    }
    return formatDate(value, "MM/yyyy");
};
// MM/YYYY to YYYY-MM-DD
const monthYearToISO = (value)=>{
    if (!value) {
        return "";
    }
    const monthYear = value.split("/");
    const year = monthYear[1];
    const month = monthYear[0];
    return "".concat(year, "-").concat(month, "-01");
};
const dateFormat = (date)=>{
    const splitDate = date.split("/");
    const [month, day, year] = splitDate;
    return "".concat(year, "-").concat(month, "-").concat(day);
};
const hoursAndMinutesToSeconds = (value)=>{
    const [hours, minutes] = value.toLowerCase().split("h");
    const convertHoursToMinutes = hoursToMinutes(parseInt(hours === null || hours === void 0 ? void 0 : hours.replace("h", "")));
    const totalOfMinutes = convertHoursToMinutes + parseInt(minutes === null || minutes === void 0 ? void 0 : minutes.replace("m", ""));
    const convertMinutesToSeconds = minutesToSeconds(totalOfMinutes);
    return convertMinutesToSeconds;
};
const timeLeftFromNow = (date, float)=>{
    if (!date) {
        return "";
    }
    const today = new Date();
    const comparedDate = new Date(date);
    const daysDifference = differenceInDays(comparedDate, today);
    if (daysDifference > 31) {
        const monthsDifference = float ? daysDifference / 30 : differenceInMonths(comparedDate, today);
        return "".concat(monthsDifference, " month").concat(monthsDifference > 1 ? "s" : "", " left");
    }
    if (daysDifference >= 1) {
        return daysDifference > 1 ? "".concat(daysDifference, " days") : "Today";
    }
    return "Ended";
};
const getDifferenceInMonths = (firstDate, secondDate)=>{
    if (!firstDate || !secondDate) {
        return "";
    }
    const date = new Date(firstDate);
    const comparedDate = new Date(secondDate);
    const numberOfMonths = differenceInMonths(comparedDate, date);
    const numberOfDays = differenceInDays(comparedDate, date);
    const monthsLabel = numberOfMonths === 1 ? "".concat(numberOfMonths, " month") : "".concat(numberOfMonths, " months");
    const daysLabel = numberOfDays === 1 ? "".concat(numberOfDays, " day") : "".concat(numberOfDays, " days");
    return numberOfMonths > 0 ? monthsLabel : daysLabel;
};
const isValidDate = (date)=>{
    return MONTH_YEAR_DATE_REGEX.test(date) || DATE_REGEX.test(date);
};
const stringToDate = (date, formatString)=>parse(date, formatString, new Date());
// TODO: Improve stringToNewYorkISO function
// Get data from dd/MM/yyyy to America/New York timezone
const stringToNewYorkISO = function(date) {
    let isEnd = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const [day, month, year] = date.split("/");
    const string = "".concat(year, "-").concat(month, "-").concat(day);
    const newTime = isEnd ? "23:59:59" : "00:00:00";
    const newDate = toDate("".concat(string, "T").concat(newTime), {
        timeZone: NY_TIMEZONE
    });
    return newDate;
};
const ISODateToNowTime = (date)=>{
    const ISODate = toISODate(date);
    const now = toISODate(new Date());
    const dateWithoutTime = ISODate.split("T")[0];
    const nowTime = now.split("T")[1];
    const newIsoDate = "".concat(dateWithoutTime, "T").concat(nowTime);
    return newIsoDate;
};
const getDifferenceInDays = (date, dateToCompare)=>{
    if (!date) {
        return "";
    }
    return differenceInDays(new Date(date), dateToCompare ? new Date(dateToCompare) : new Date());
};
const isTodayOrLater = (date)=>{
    if (!date) {
        return false;
    }
    const today = new Date();
    const comparedDate = new Date(date);
    return !isBefore(today, comparedDate);
};
// ISO string
const removeDateTimezone = (date)=>{
    if (date.includes("+")) {
        var ref;
        return (ref = date.split("+")) === null || ref === void 0 ? void 0 : ref[0];
    }
    if (date.includes("Z")) {
        var ref1;
        return (ref1 = date.split("Z")) === null || ref1 === void 0 ? void 0 : ref1[0];
    }
    const arrayDate = date.split("-");
    arrayDate.pop();
    return arrayDate.join("-");
};
// ISO string
const formatWithoutTimezone = (date, dateDisplayFormat)=>{
    if (!date) {
        return "";
    }
    const newDate = new Date(removeDateTimezone(date));
    return format(newDate, dateDisplayFormat);
};
const removeTimeFromDate = (date)=>{
    if (typeof date === "string") {
        return date.replace(REMOVE_TIME_REGEX, "");
    }
    const ISODate = toISODate(date);
    return ISODate.replace(REMOVE_TIME_REGEX, "");
};
const differenceInDaysToToday = (date)=>{
    if (!date) {
        return "";
    }
    const newDate = removeTimeFromDate(date);
    const days = differenceInDays(new Date(), new Date(newDate));
    if (days === 0) {
        return "Today";
    }
    if (days < 2) {
        return "Yesterday";
    }
    if (days > 31) {
        return formatDate(date, "MMM do, yyyy");
    }
    return "".concat(days, "d ago");
};
// TODO: Check the necessity of this formatter when Company payments integrated
// "new Date()" replacer to avoid timezone problems
const dateWithoutTimezone = (date)=>{
    // reduces 1 days because of GMT -3 timezone
    const newDate = date ? new Date(date) : new Date();
    // Converts to ISO string and remove "Z" and call date Object with new string
    const dateObjectWithoutTimeZone = new Date(newDate.toISOString().slice(0, -1));
    return dateObjectWithoutTimeZone;
};
const formatReadableDate = (date)=>{
    const formattedDate = differenceInDaysToToday(date);
    if (formattedDate === "Today" || formattedDate === "Yesterday" || formattedDate.includes("ago")) {
        return formattedDate;
    }
    return "on ".concat(formattedDate);
};

// EXTERNAL MODULE: ../../libs/shared-components/src/components/terms/index.module.scss
var index_module = __webpack_require__(4252);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ../../libs/shared-components/src/components/terms/index.tsx




const TERMS_TITLE = {
    [types_generated/* TermType.CookiePolicy */.K5.CookiePolicy]: "Cookie Policy",
    [types_generated/* TermType.PrivacyPolicy */.K5.PrivacyPolicy]: "Privacy Policy",
    [types_generated/* TermType.TermsOfUse */.K5.TermsOfUse]: "Terms of Use"
};
const Terms = (param)=>{
    let { role , type , isFetchEnabled =true  } = param;
    var ref, ref1, ref2;
    const { data  } = useGetCurrentTermByRoleAndTypeQuery({
        input: {
            role: role,
            type: type
        }
    }, {
        enabled: isFetchEnabled
    });
    if (!(data === null || data === void 0 ? void 0 : (ref = data.getCurrentTermByRoleAndType) === null || ref === void 0 ? void 0 : ref.textHtml)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (index_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: (index_module_default()).heading,
                    children: TERMS_TITLE[type]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (index_module_default()).version,
                    children: "Version ".concat(data === null || data === void 0 ? void 0 : (ref1 = data.getCurrentTermByRoleAndType) === null || ref1 === void 0 ? void 0 : ref1.versionName, " • Updated on ").concat(formatDate(data === null || data === void 0 ? void 0 : (ref2 = data.getCurrentTermByRoleAndType) === null || ref2 === void 0 ? void 0 : ref2.versionDate, "MMM dd, yyyy"))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                    className: (index_module_default()).divisor
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (index_module_default()).terms,
                    dangerouslySetInnerHTML: {
                        __html: data.getCurrentTermByRoleAndType.textHtml
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var terms = ((/* unused pure expression or super */ null && (Terms)));


/***/ }),

/***/ 25352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ WebsiteSeo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55351);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



const WebsiteSeo = (param)=>{
    let { seo  } = param;
    const websiteUrl = "https://olby.com";
    const { asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const asPathWithoutParams = asPath.split("?")[0];
    const canonical = websiteUrl + asPathWithoutParams;
    const websiteSeo = {
        canonical,
        ...seo
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        ...websiteSeo
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WebsiteSeo);


/***/ }),

/***/ 49661:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"terms-container":"styles_terms-container__UsWuL","terms-wrapper":"styles_terms-wrapper__aF2iv","fade-in-up":"styles_fade-in-up__e_etu","fade-in-opacity":"styles_fade-in-opacity__yLbRG","fade-in-up-opacity":"styles_fade-in-up-opacity__AknQU","fade-out-opacity":"styles_fade-out-opacity__d_g0P","fade-out-left":"styles_fade-out-left__8mxF3"};

/***/ }),

/***/ 4252:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"terms_container__l_uJN","content":"terms_content__Ym25p","heading":"terms_heading__UpoeU","theme--light":"terms_theme--light__hr_W7","theme--dark":"terms_theme--dark__TTZRK","version":"terms_version__B_0Ar","divisor":"terms_divisor__BtTCz","terms":"terms_terms__2yni1","fade-in-up":"terms_fade-in-up__ENV_3","fade-in-opacity":"terms_fade-in-opacity__7V1Sz","fade-in-up-opacity":"terms_fade-in-up-opacity__xdbsD","fade-out-opacity":"terms_fade-out-opacity__rX__s","fade-out-left":"terms_fade-out-left__moYQ4"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [350,82,601,559,774,888,179], function() { return __webpack_exec__(45958); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);